class RecentlyViewedProducts extends HTMLElement {
  constructor () {
    super();

    this.onScrollIntoView = this.onScrollIntoView.bind(this);

    this.state = {
      loaded: false
    }

    const observer = new IntersectionObserver(this.onScrollIntoView);
    observer.observe(this);
  }

  onScrollIntoView (entries) {
    if (!entries[0].isIntersecting || this.state.loaded) {
      return;
    }

    this.state.loaded = true;

    // Load list of recently viewed product handles from localstorage
    const recentlyViewed = JSON.parse(RecentlyViewed.getRecentlyViewed() || '[]');
    // Generate search query to load each product by its handle
    const query = recentlyViewed
      .includes(this.dataset.handle)
      ? recentlyViewed.map((handle) => `handle:${handle}`).join(' OR ') : '';

    // Request search results using product-grid view to render product grid containing queried products
    return fetch(`/search?view=product-grid&type=product&q=${query}`)
      .then((response) => response.text())
      .then((responseText) => {
        const newSectionEl = new DOMParser().parseFromString(responseText, 'text/html');

        // Convert NodeList to Array
        const productsGrid = Array.prototype.slice.call(newSectionEl.querySelectorAll('[data-handle]'));

        // Sort product cards based on sequence of handles in recently viewed products lis
        // const sortedProductCards = productsGrid.sort(
        //   (a, b) => recentlyViewed.indexOf(a?.dataset.handle) - recentlyViewed.indexOf(b?.dataset.handle)
        // );

        // console.log('after', sortedProductCards);

        // TODO: FIX THIS
        // Re-order product card DOM nodes based on sorted order
        // sortedProductCards.forEach((productCard) => {
        //   const productLink = productCard.querySelector('a');
        //   productLink.href = productLink.href.split('?')[0];
        //   productCard.parentElement.appendChild(productCard);
        // });

        // Find all descendant elements with data-slot attribute and update each with new contents
        let oldSlots = this.querySelectorAll('[data-slot]');

        oldSlots.forEach((oldSlotEl) => {
          const slotName = oldSlotEl.dataset.slot;
          // Replace original content with new slot elements
          oldSlotEl.innerHTML = newSectionEl.querySelector(`[data-slot="${slotName}"]`).innerHTML;
        });

        // Remove "hidden" class to reveal module after products have been loaded
        // this.querySelector('.hidden').classList.remove('hidden');
      })
  }
}
window.addEventListener('DOMContentLoaded', () => {
  if (window.RecentlyViewed) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }
});
